import { render, staticRenderFns } from "./DepartmentAlert.vue?vue&type=template&id=36a7efa5"
import script from "./DepartmentAlert.vue?vue&type=script&lang=js"
export * from "./DepartmentAlert.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAlert.vue?vue&type=style&index=0&id=36a7efa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports